import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const CALENDAR_BUILDER_FEATURE_GROUP: FeatureGroup = {
  guid: '1808d649-8854-4963-9bce-2f8c10f2ff00',
  name: 'calendar-builder',
  description: 'Calendar Builder app — design event calendars synced with Altru',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
